import React from 'react';
function ErrorPage() {
    return (
        <main id="main" className="sectionOne">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-8">
                        <div className="text">
                            <h1 className="heading-large">The Adult Social Care referral form is currently unavailable</h1>
                            <div>
                                <p>In the meantime if  you would like to make a referral please get in touch on
                                    <b> 0113 222 4401</b> or email our team at <a href='mailto: leedsadults@leeds.gov.uk' className="govuk-link">leedsadults@leeds.gov.uk.</a>
                                </p>
                                <p>Our working hours are Monday to Thursday, 9am until 5pm and Friday from 9am until 4:30pm except for Bank Holidays.</p>
                                <p>We apologise for any inconvenience, please try again later.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};
export default ErrorPage;
